import { LongOpToolBarViewModel } from './long-op-tool-bar-view-model';
import { BaseScheduleLongOpOrchestratorViewModelInterface } from './base-schedule-long-op-orchestrator-view-model.interface';
import { ToolBarViewModelInterface } from '../tool-bar-view-model.interface';
import { CommandFactory } from '../commands/command-factory';
import { CommandTypes } from '../commands/command-types';
import type { UICommandInterface } from '@nts/std/interfaces';

export class BaseScheduleLongOpToolBarViewModel<TOrchestrator extends BaseScheduleLongOpOrchestratorViewModelInterface = BaseScheduleLongOpOrchestratorViewModelInterface> extends LongOpToolBarViewModel implements ToolBarViewModelInterface {

    override get orchestrator(): TOrchestrator {
        return this._orchestrator as TOrchestrator;
    }

    protected override addHomeCommands(): Array<UICommandInterface> {
        const items = super.addHomeCommands();

        items.push(
            CommandFactory.createUICommandWithType(
                CommandTypes.Schedule,
                async (x) => await this.orchestrator.schedule(),
                () => this.orchestrator.canSchedule(),
                null,
                () => this.orchestrator.isVisibleSchedule()
            )
        );

        return items;
    }
}
